<template>
    <div 
        class="text-right"   
        v-b-tooltip.hover 
        :title="title" >{{ displayValue }}
    </div>
</template>
<script>
export default {
    name:"amountColumn",
    props:['value'],
    data(){
      return {
        title: this.formatHoverCurrency(this.value),
        displayValue: this.formatThousands(this.value) ?? 0
      }
    },
    methods:{
      formatHoverCurrency(amount) {
        const formattedAmount = new Intl.NumberFormat("en-US", { 
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
          roundingIncrement: 1,
        }).format(amount);

        return formattedAmount
      },
      formatThousands(amount) {
        const formattedAmount = new Intl.NumberFormat("en-US", { 
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
          roundingIncrement: 1,
        }).format(amount);

        let splitAmount = formattedAmount.split(".");
        return splitAmount[0];  
      },
    }
}
</script>
